<section id="about" class="about section-bg">
  <div class="container">
    <div class="row d-flex flex-column justify-content-center align-items-center">
      <!--<div class="col-xl-5 col-lg-6 video-box d-flex justify-content-center align-items-stretch" data-aos="fade-right">
        <a target="_blank" href="https://www.youtube.com/watch?v=yorZwSq_74U" class="venobox play-btn mb-4" data-vbtype="video" data-autoplay="true"></a>
      </div>-->

      <div class="col-xl-9 col-lg-9 icon-boxes d-flex flex-column align-items-stretch justify-content-center py-5 px-lg-5">
        <h3 data-aos="fade-up">About the Contest</h3>

        <div class="icon-box" data-aos="fade-up">
          <div class="icon"><fa-icon [icon]="paletteIcon" class="fa-2x aboutIcon"></fa-icon></div>
          <h4 class="title">Open to All</h4>
          <p class="description">
            Kindergarten through 12th grade students across North Texas compete in the
            <a target="_blank" href="https://www.dart.org/guide/supporting-services/transit-education/dart-student-art-contest">Student Art Contest</a>.
          </p>
        </div>

        <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
          <div class="icon"><fa-icon [icon]="lighbulbIcon" class="fa-2x aboutIcon"></fa-icon></div>
          <h4 class="title">Illustrating the Theme</h4>
          <p class="description">
            Each year, students create wonderful works of art inspired by the provided theme. For {{ lastCompletedContestYear }}, DART offered the words “Explore DART’s 13 cities!” as inspiration. This theme gave young artists an excuse to get out and explore someplace new on DART!
          </p>
        </div>

        <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
          <div class="icon"><fa-icon [icon]="handshakeIcon" class="fa-2x aboutIcon"></fa-icon></div>
          <h4 class="title">Our Partners</h4>
          <p class="description">DART’s Student Art Contest is made possible by the generosity of our valued partners:</p>

          <div class="row description">

            <div class="col-sm-4">
              <b>Principal Partner</b><br />
              <a href="https://advocatemag.com" target="_blank">Advocate</a><br />
            </div>

            <div class="col-sm-4">
              <b>Media Partners</b><br />
              <a href="https://www.dallasnews.com/espanol/al-dia/" target="_blank">Al Día</a><br />
              <a href="https://dfwchild.com" target="_blank">DFW Child</a><br />
              <a href="https://www.goodlifefamilymag.com" target="_blank">Good Life Family</a><br />
              <a href="https://localprofile.com" target="_blank">Local Profile</a><br />
              <a href="https://www.nbcdfw.com" target="_blank">NBC 5</a><br />
              <a href="https://planomagazine.com" target="_blank">Plano Magazine</a><br />
              <a href="https://www.telemundodallas.com" target="_blank">Telemundo 39</a><br />
              <a href="https://www.dallasnews.com" target="_blank">Dallas Morning News</a>
            </div>

            <div class="col-sm-4">
              <b>Community Partners</b><br />
              <a href="https://www.childrensaquarium.com" target="_blank">Children's Aquarium Dallas</a><br />
              <a href="https://dma.org" target="_blank">Dallas Museum of Art</a><br />
              <a href="https://www.dallaszoo.com" target="_blank">Dallas Zoo</a><br />
              <a href="https://flightmuseum.com" target="_blank">Frontiers of Flight Museum</a><br />
              <a href="https://www.hpb.com" target="_blank">Half Price Books</a><br />
              <a href="https://madison214.com" target="_blank">Madison</a><br />
              <a href="https://www.nashersculpturecenter.org" target="_blank">Nasher Sculpture Center</a><br />
              <a href="https://www.perotmuseum.org" target="_blank">Perot Museum of Nature and Science</a><br />
              <a href="https://www.proxypropertymgmt.com" target="_blank">Proxy</a><br />
              <a href="https://sparkdallas.org" target="_blank">Spark</a><br />
              <a href="https://www.wsp.com/en-us/contact-us/offices/united-states/texas/dallas/002952" target="_blank">WSP</a>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</section>
